export const toFavoritesList = '/customer/favorites'
export const toFavoritesDetails = (listId: number) => `/customer/favorites/${listId}`
